import AsyncPage from 'pages/AsyncPage'
import log from 'lib/log'
import { loadPublishedPostById } from 'actions/posts'

import universal from 'react-universal-component'
const component = universal(props => import('./SharePublishedPostPage'))

class AsyncSharePublishedPostPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const { location: { payload: { postId } } } = getState()
    try {
      await loadPublishedPostById({ _id: postId })(dispatch, getState, opts)
    } catch (err) {
      log.error(err)
    }
  }
}

export default new AsyncSharePublishedPostPage()
